// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import { bindActionCreators } from 'redux';
import { Row, Col } from 'react-flexbox-grid';

import Button from '../common/ButtonComp';
import './AdminComp.css';
import AppActions from '../actions/admin.actions';

function debounce(fn, delay) {
  var timer = null;
  return function() {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function() {
      fn.apply(context, args);
    }, delay);
  };
}

class AdminComp extends Component {
  state = {
    email: null,
    siteName: null
  };

  constructor(props) {
    super(props);

    this.findUsers = debounce(this.findUsers, 300);
  }

  toggleSelection = (u) => {
    const { adminSecret } = this.props.me.user;
    document.cookie = `uid=${u.id}; path=/`;
    document.cookie = `admin=${adminSecret}; path=/`;
    window.location.href = '/profile';
  };

  findUsers = (name, value) => {
    const { appActions } = this.props;
    appActions.guessBy(name, value);
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
    this.findUsers(name, value);
  };

  render() {
    const { email, uid, apiKey } = this.state;
    const { userList } = this.props;

    return (
      <div className="admin">
        <h1 className="admin-header">ADMIN</h1>
        <div className="content">
          <Row>
            <Col xs={6}>
              <Input
                type="text"
                label="User email"
                value={email}
                onChange={this.handleChange.bind(this, 'email')}
              />
            </Col>
            <Col xs={6}>
              <Input
                type="text"
                label="User ID"
                value={uid}
                onChange={this.handleChange.bind(this, 'uid')}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Input
                type="text"
                label="Project API Key"
                value={apiKey}
                onChange={this.handleChange.bind(this, 'apiKey')}
              />
            </Col>
          </Row>
          <Row className="admin-line">
            <Col xs={6}>Email</Col>
            <Col xs={1}>Projects</Col>
            <Col xs={2}>Created</Col>
            <Col xs={2}>Updated</Col>
            <Col xs={1}>SwitchTO</Col>
          </Row>
          {userList.map((u, i) => {
            const status = getStatusFromUser(u);
            const userClassName = Object.keys(status)
              .map((key) => (status[key] ? key : ''))
              .join(' ');

            return (
              <Row className="admin-line users" key={i}>
                <Col xs={6}>
                  <span className={userClassName}>{u.email}</span>
                </Col>
                <Col xs={1}>{u.projects.length}</Col>
                <Col xs={2}>{formatDate(new Date(u.created))}</Col>
                <Col xs={2}>{formatDate(new Date(u.last_updated))}</Col>
                <Col xs={1}>
                  <Button medium primary onClick={this.toggleSelection.bind(this, u)}>
                    GO
                  </Button>
                </Col>
              </Row>
            );
          })}
        </div>
      </div>
    );
  }
}

function getStatusFromUser(user) {
  var value = {
    isProfileId: 0,
    isSearchConsole: 0,
    isUploadAccount: 0,
    isPlan: 0,
    isDone: 0,

    isPotentiallyPaid: 0,
    isPaid: 0,
    isInTrial: 0,
    monthlyIncome: 0,
    isRevoked: 1
  };

  user.projects.forEach((p) => {
    if (!value.isProfileId) value.isProfileId = !!~p.wizard.indexOf('web-property-setup') ? 1 : 0;
    if (!value.isSearchConsole)
      value.isSearchConsole = !!~p.wizard.indexOf('search-console-setup') ? 1 : 0;
    if (!value.isUploadAccount)
      value.isUploadAccount = !!~p.wizard.indexOf('create-upload-account') ? 1 : 0;
    if (!value.isPlan) value.isPlan = !!~p.wizard.indexOf('select-plan') ? 1 : 0;
    if (!value.isDone) value.isDone = !!~p.wizard.indexOf('done') ? 1 : 0;
    var isPotentiallyPaid =
      !!~p.wizard.indexOf('done') && p.plan.id === 'free' && p.predictedNumberOfUrls > 25;
    if (!value.isPotentiallyPaid) value.isPotentiallyPaid = isPotentiallyPaid ? 1 : 0;
    if (!value.isPaid && p.plan && p.plan.id) value.isPaid = p.plan.id !== 'free' ? 1 : 0;
    if (!value.isInTrial)
      value.isInTrial =
        !!~p.wizard.indexOf('done') &&
        p.plan.id === 'free' &&
        p.permissions.urlsToProcess === 1000 &&
        !p.disabled &&
        !!p.origin &&
        !!p.dest &&
        p.predictedNumberOfUrls > 25
          ? 1
          : 0;
    value.monthlyIncome += p.plan && p.plan.price ? p.plan.price : 0;
    if (!p.revoked && !p.disabled && value.isRevoked) value.isRevoked = 0;
  });

  return value;
}

function mapStateToProps(state) {
  return {
    me: state.me,
    userList: state.admin.list || []
  };
}

function formatDate(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();

  var strTime = hours + ':' + minutes;
  return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear() + '  ' + strTime;
}

function mapDispatchToProps(dispatch) {
  return {
    appActions: bindActionCreators(AppActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminComp);



// WEBPACK FOOTER //
// ./src/admin/AdminComp.js